export function create(queryParams = {}) {
  return Object.keys(queryParams)
    .sort()
    .map(param => `${param}=${encodeURIComponent(queryParams[param])}`)
    .join('&');
}
